import { Link } from "react-router-dom";
import { FadeUp, MaskedReveal } from "@/components/Motion";

export default function PaymentCancel() {
  return (
    <div className="pt-20 min-h-[70vh]" data-testid="payment-cancel-page">
      <section className="editorial-container">
        <FadeUp>
          <div className="max-w-3xl">
            <span className="overline text-ink/60">Checkout cancelled</span>
            <h1 className="mt-6 font-serif text-6xl md:text-7xl leading-[1] tracking-tight text-ink">
              <MaskedReveal text="No envelope, yet." as="span" className="block italic" animate />
            </h1>
            <p className="mt-8 font-serif text-2xl text-ink/75 leading-relaxed">
              No charge has been made. Whenever you're ready, the Mail Club is here.
            </p>
            <div className="mt-10 flex gap-4">
              <Link to="/mail-club" className="btn-pill">Try again</Link>
              <Link to="/" className="btn-pill ghost">Return home</Link>
            </div>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
